import angular from "angular";

import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";

import AuthServiceProvider from "./AuthServiceProvider";
import IdTokenClaimsInterceptor from "./IdTokenClaimsInterceptor";

export default angular
    .module("trackerbase-app.services.auth-service", DependencyListBuilder([
        AuthServiceProvider.dependencies,
        IdTokenClaimsInterceptor.dependencies
    ]))
    .provider("TbAuthService", AuthServiceProvider)
    .service("IdTokenClaimsInterceptor", IdTokenClaimsInterceptor)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/auth/index.js
// module id = h95T
// module chunks = 1